// eslint-disable-next-line import/no-internal-modules
import Icon, { IconProps } from '@insided/deprecated-preact-components/assets'
import classNames from 'classnames'
import { ComponentChildren, FunctionalComponent } from 'preact'

export type ButtonVariant =
  | 'text'
  | 'brand' // @deprecated use 'primary'
  | 'primary'
  | 'secondary'
  | 'secondary-reversed'
  | 'save'
  | 'danger'
  | 'warning'
  | 'success'
  | 'approval'

export interface ButtonProps {
  className?: string
  noMargin?: boolean
  disabled?: boolean
  fullWidth?: boolean
  IconProps?: Omit<IconProps, 'icon'>
  icon?: IconProps['icon']
  startIcon?: IconProps['icon']
  endIcon?: IconProps['icon']
  onClick?: JSX.MouseEventHandler
  title?: ComponentChildren
  variant?: ButtonVariant
  isLoading?: boolean
  children?: ComponentChildren
  outlined?: boolean
  type?: 'submit' | 'button'
  size?: 'small' | 'medium'
  oldStyle?: boolean
}

const DEFAULT_ICON_PROPS: Omit<IconProps, 'icon'> = {
  size: 16
}

const hasChildren = (children?: ComponentChildren): boolean => {
  if (!children) {
    return false
  }
  // for some reason Preact puts an empty array for children
  // [Preact X] Check the behavior
  if (Array.isArray(children) && children.length === 0) {
    return false
  }
  return true
}

/**
 * This Button, ex. ButtonControl has no `"newStyle"` property, since it's "new" by default.
 */
const Button: FunctionalComponent<ButtonProps> = ({
  disabled,
  fullWidth,
  className,
  icon,
  endIcon,
  noMargin,
  startIcon,
  oldStyle,
  onClick,
  IconProps = DEFAULT_ICON_PROPS,
  title,
  variant = 'secondary',
  isLoading,
  outlined,
  type = 'button',
  size = 'small',
  children,
  ...restProps
}) => {
  if (!icon && !title && !children) {
    return null
  }
  return (
    <button
      className={
        oldStyle
          ? className
          : classNames(className, 'button-control-new', `button-control-new--${size}`, {
              [`button-control-new--${variant}`]: !outlined,
              [`button-control-new--${variant}--outlined`]: outlined,
              'button-control-new--no-margin': noMargin,
              'button-control-new--full-width': fullWidth,
              'button-control-new--icon': icon,
              'button-control-new--endIcon': endIcon,
              'button-control-new--startIcon': startIcon
            })
      }
      disabled={disabled}
      onClick={onClick}
      title={hasChildren(children) && typeof title === 'string' ? title : undefined}
      type={type}
      {...restProps}
    >
      {isLoading ? (
        <div>
          <Icon icon='loader' {...IconProps} />
          <span className='button-control__title--hide'>
            {hasChildren(children) ? children : title}
          </span>
        </div>
      ) : (
        <div>
          {startIcon && <Icon icon={startIcon} {...IconProps} />}
          {icon && <Icon icon={icon} {...IconProps} />}
          {hasChildren(children) ? children : title}
          {endIcon && <Icon icon={endIcon} {...IconProps} />}
        </div>
      )}
    </button>
  )
}

export default Button
